import React from 'react';
import { scrollToBuy } from '../utils/constants';
type CtaButtonProps = {
  label?: string;
  className?: string;
  href?: string;
};
export function CtaButton({
  label = 'GET YOGA TEACHING VAULT™ NOW',
  className = '',
  href
}: CtaButtonProps) {
  const base = 'inline-flex w-full max-w-xl items-center justify-center rounded-full bg-brand px-6 py-4 text-center font-head text-sm font-bold uppercase leading-tight tracking-wide text-white shadow-lg shadow-brand/30 transition hover:bg-brand-dark active:scale-[0.99] sm:px-10 sm:text-lg';
  if (href) {
    return <a href={href} className={`${base} ${className}`} data-id="element-66" data-mp="10adhjs8r7m2s">
        {label}
      </a>;
  }
  return <button type="button" onClick={scrollToBuy} className={`${base} ${className}`} data-id="element-67" data-mp="vbaa615ax3rn">
      {label}
    </button>;
}